import { NoticeClient } from "./notices";
import { PopupBannerClient } from "./popupBanners";

export class CommunicationClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/communications`;

    this.notices = new NoticeClient(this.httpClient, this.baseURL);
    this.popupBanners = new PopupBannerClient(this.httpClient, this.baseURL);
  }
}
